<template>
  <c-data-filters>
    <div class="row">
      <div class="col">
        <div class="row flex-grow-1">
          <div class="col-lg-6 mb-3">
            <label>Date From</label>

            <c-date ref="dateFrom" v-model="filters.dateFrom" placeholder=""/>
          </div>

          <div class="col-lg-6 mb-3">
            <label>Time From</label>

            <flatpickr
              v-model="filters.timeFrom"
              :value="filters.timeFrom"
              :config="timeConfig"
              data-field="timeFrom"
              :disabled="!filters.dateFrom"
              class="form-control time-single"
            />
          </div>
        </div>
      </div>

      <div class="col-auto d-flex align-items-center">
        <p class="form-control-plaintext text-muted mt-2 px-2">-</p>
      </div>

      <div class="col">
        <div class="row flex-grow-1">
          <validation-provider tag="div" class="col-lg-6 mb-3" name="date to" vid="dateTo" :rules="{ date_after: filters.dateFrom }" v-slot="{ failed }">
            <label>Date To</label>

            <c-date v-model="filters.dateTo" placeholder="" :class="{ 'is-invalid': failed }"/>
            <c-help-block/>
          </validation-provider>

          <validation-provider tag="div" class="col-lg-6 mb-3" name="time to" vid="timeTo" rules="" v-slot="{ failed }">
            <label>Time To</label>

            <flatpickr
              v-model="filters.timeTo"
              :value="filters.timeTo"
              :config="timeConfig"
              data-field="timeTo"
              :disabled="!filters.dateTo"
              class="form-control time-single"
              :class="{ 'is-invalid': failed }"
            />
            <c-help-block/>
          </validation-provider>
        </div>
      </div>
      <div class="col" v-if="showPercentageFilter">
        <label>Percentage of Screen Affected</label>

        <c-input
          as="multiselect"
          v-model="selectedRangeOption"
          placeholder="Select"
          :show-labels="false"
          :options="percentageOptions"
          label="name"
          track-by="id"
        />
      </div>
    </div>
  </c-data-filters>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import dayjs from 'dayjs'

export default {
  mixins: [useQueryParamFilters()],

  props: {
    showPercentageFilter: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      filters: {
        dateFrom: null,
        timeFrom: null,
        dateTo: null,
        timeTo: null,
        selectedRange: null
      },
      percentageOptions: [
        { id: '100', name: '100–80%' },
        { id: '80', name: '80–60%' },
        { id: '60', name: '60–40%' },
        { id: '40', name: '40–20%' },
        { id: '20', name: '20–0%' },
      ],
      timeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'h:i K',
        allowInput: false,
        minuteIncrement: 1,
        onChange: (times, timeString, instance) => {
          const field = instance.element.dataset.field
          const formattedTime = dayjs(timeString, 'h:mm A').isValid() ? dayjs(timeString, 'h:mm A').format('HH:mm:ss') : null
          const value = { ...this.user, [field]: formattedTime }

          this.$emit('update', this.index, value)
        }
      },
    }
  },
  computed: {
    selectedRangeOption: {
      get () {
        return this.percentageOptions.find(opt => opt.id === this.filters.selectedRange) || null
      },

      set (opt) {
        this.filters.selectedRange = opt ? opt.id : null
        this.$emit('update', this.index, { selectedRange: this.filters.selectedRange })
      }
    }
  },

  methods: {
    updateSearch: debounce(function (value) {
      this.filters.search = value
    }, 500),

    timeFromFocused () {
    }
  },
}
</script>
